import React from 'react';

function AboutUsPage() {
  return (
    <div className="about-us-page">
      <div 
        className="about-us-hero"
        style={{
          background: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('/images/products/prodgeneral.jpeg') center/cover no-repeat`
        }}
      >
        <h1 className="about-us-title">Sobre Nosotros</h1>
        <p className="about-us-tagline">Creando experiencias aromáticas únicas desde Monterrey</p>
      </div>

      <div className="about-us-content">
        <section className="about-us-section">
          <div className="about-us-text">
            <h2>Nuestra Historia</h2>
            <p>
              Somos una empresa regiomontana con sede en Monterrey, Nuevo León, dedicada a crear 
              experiencias aromáticas excepcionales para transformar tus espacios.
            </p>
            <p>
              Con pasión y dedicación, nos especializamos en la creación de velas aromáticas, 
              difusores de ambiente y perfumes de alta calidad que despiertan emociones y 
              crean ambientes inolvidables.
            </p>
          </div>
          <div className="about-us-image">
            <img src="/images/products/prodgeneral.jpeg" alt="Productos Sanro" />
          </div>
        </section>

        <section className="about-us-products">
          <h2>¿Qué Ofrecemos?</h2>
          <div className="products-showcase">
            <div className="product-item">
              <div className="product-icon">
                <img src="/images/products/velas.jpeg" alt="Velas" />
              </div>
              <h3>Velas Aromáticas</h3>
              <p>
                Velas artesanales de alta calidad que llenan tus espacios con fragancias 
                cuidadosamente seleccionadas.
              </p>
            </div>

            <div className="product-item">
              <div className="product-icon">
                <img src="/images/products/difusores.jpeg" alt="Difusores" />
              </div>
              <h3>Difusores</h3>
              <p>
                Difusores elegantes que mantienen tu hogar u oficina con un aroma constante 
                y sofisticado.
              </p>
            </div>

            <div className="product-item">
              <div className="product-icon">
                <img src="/images/products/perfume.jpeg" alt="Perfumes" />
              </div>
              <h3>Perfumes</h3>
              <p>
                Fragancias únicas inspiradas en las mejores casas de perfumería del mundo, 
                creadas para definir tu esencia.
              </p>
            </div>
          </div>
        </section>

        <section className="about-us-values">
          <h2>Nuestro Compromiso</h2>
          <div className="values-grid">
            <div className="value-item">
              <h3>Calidad</h3>
              <p>Utilizamos solo los mejores ingredientes y materiales para garantizar productos excepcionales.</p>
            </div>
            <div className="value-item">
              <h3>Pasión</h3>
              <p>Cada producto es creado con dedicación y amor por el arte de los aromas.</p>
            </div>
            <div className="value-item">
              <h3>Innovación</h3>
              <p>Constantemente buscamos nuevas fragancias y técnicas para sorprender a nuestros clientes.</p>
            </div>
            <div className="value-item">
              <h3>Local</h3>
              <p>Orgullosamente regiomontanos, apoyando el talento y la economía de Nuevo León.</p>
            </div>
          </div>
        </section>

        <section className="about-us-cta">
          <h2>Descubre Nuestros Aromas</h2>
          <p>Explora nuestra colección completa y encuentra la fragancia perfecta para ti.</p>
          <a href="#shop" className="cta-button">Ver Tienda</a>
        </section>
      </div>
    </div>
  );
}

export default AboutUsPage;
